import Joi from '@hapi/joi'

export const BLFactoryWeighSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    factoryID: Joi.number().invalid(0).required().label("Factory").messages({
        "any.invalid": `Factory cannot have invalid characters`,
        "any.required": `Factory required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Route").messages({
        "any.invalid": `Route cannot have invalid characters`,
        "any.required": `Route required`
    }),
    Date: Joi.string().invalid("").label("Date")
        
    
}